<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/industry/finance_banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">产业应用</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function01.png" alt="">
          家用电器
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function02.png" alt="">
          数码3C
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function03.png" alt="">
          酒水饮料
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function04.png" alt="">
          农资行业
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function05.png" alt="">
          交通出行
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function06.png" alt="">
          家居建材
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function07.png" alt="">
          餐饮行业
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/function08.png" alt="">
          快消行业
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">产品优势</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/industry/advantage01.png" alt="">
          <span class="title">产品多元</span>
          <span class="text">基于客户需求和银行风险定位，提供订单、应收账款、融资租赁等多元化的供应链融资产品，帮助中小企业匹配到最合适的金融产品。</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/advantage02.png" alt="">
          <span class="title">融资便捷</span>
          <span class="text">整合银行及第三方支付账户体系，基于真实贸易背景帮助企业打通产业链交易全流程，提高授信成功率，提升企业融资效率。</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/advantage03.png" alt="">
          <span class="title">流程简化</span>
          <span class="text">搭建互联网交易平台，支持企业在线进行融资申请、签约、收款等操作，提供远程账户开立服务，进一步降低企业操作门槛。</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/advantage04.png" alt="">
          <span class="title">风控安全</span>
          <span class="text">构建场景式金融风控模型，从企业资格、融资额度、材料审核、项目审批等多个环节进行科学管理，规范供应链生态健康发展，保障资金安全。</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/industry/advantage05.png" alt="">
          <span class="title">产业协同</span>
          <span class="text">大数据实时监测预警企业信用变化、供应链异动，实现产业端数据传递闭环，多核心企业资源共享，实现产业协同，多场景融合。</span>
        </div>
      </div>
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">合作机构</div>
      </div>
      <div class="content">
        <img src="@/assets/Mobile/images/industry/org01.png" alt="">
        <img src="@/assets/Mobile/images/industry/org02.png" alt="">
        <img src="@/assets/Mobile/images/industry/org03.png" alt="">
        <img src="@/assets/Mobile/images/industry/org04.png" alt="">
        <img src="@/assets/Mobile/images/industry/org05.png" alt="">
      </div>
    </div>
    <Case title="金融服务" />
    <ContactForm info-sources="金融服务" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Finance,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  .content {
    padding: 8px 0;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .item {
      display: flex;
      flex-direction: column;
      margin: 15px;
      font-size: 12px;
      line-height: 22px;
    }
    img {
    width: 62px;
    height: 62px;
    }
  }
}
.block02 {
  background-color: #FAFAFA;
  .content {
    padding: 16px 13px;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: start;
    .item {
      display: flex;
      flex-direction: column;
      margin: 4px;
      font-size: 12px;
      line-height: 22px;
      width: 108px;
      height: 164px;
      background: #FFFFFF;
      box-shadow: 0px 0px 5px 0px rgba(221, 221, 221, 0.5);
      border-radius: 3px;
      justify-content: center;
      align-items: center;
      img {
        width: 28px;
        height: 28px;
      }
      .title {
        margin: 7px 0;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
      }
      .text {
        display: inline-block;
        width: 80px;
        font-size: 8px;
        line-height: 12px;
        -webkit-text-size-adjust: none;
      }
    }
  }
}
.block03 {
  .content {
    padding: 20px 6px;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: start;
    img {
      flex-direction: column;
      margin: 5px;
      width: 111px;
      height: 48px;
    }
  }
}
</style>
